module.exports = __webpack_public_path__ + "img/album10_10.ec51702c.jpg";